import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import clsx from 'clsx';
import React, { type ReactNode, memo, useEffect } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

import styles from './InformationAlertBanner.css';

export const enum InformationBannerType {
    alert = 'alert',
    info = 'info',
}

interface InformationAlertProps {
    title: string | ReactNode;
    content: string | ReactNode;
    primaryButtonTitle?: string;
    secondaryButtonTitle?: string | false;
    type: InformationBannerType;

    onShow?(): void;

    onPrimaryClick?(): void;

    onSecondaryClick?(): void;
}

export const InformationAlertBanner = memo<InformationAlertProps>(
    ({ title, content, primaryButtonTitle, secondaryButtonTitle, type, onShow, onPrimaryClick, onSecondaryClick }) => {
        useEffect(() => {
            onShow?.();
        }, [onShow]);

        return (
            <div className={clsx(styles.root, styles[`root_${type}`])} data-qa-id="information-alert-banner">
                <Icon20InfoCircleOutline className={styles.icon} />
                <div className={styles.content}>
                    <div className={styles.title} data-qa-id="title">
                        {title}
                    </div>
                    <div className={styles.text} data-qa-id="content">
                        {content}
                    </div>
                </div>
                <div className={styles.buttons}>
                    {primaryButtonTitle && (
                        <Button
                            className={styles.button}
                            data-name="primary-bttn"
                            data-qa-id="primary-bttn"
                            theme="octavius"
                            sizeMode={ButtonSizeMode.small}
                            onClick={onPrimaryClick}
                            primary={type === InformationBannerType.info}
                            error={type === InformationBannerType.alert}
                        >
                            {primaryButtonTitle}
                        </Button>
                    )}
                    {secondaryButtonTitle && (
                        <Button
                            className={styles.button}
                            onClick={onSecondaryClick}
                            theme="octavius"
                            sizeMode={ButtonSizeMode.small}
                            data-name="secondary-bttn"
                            data-qa-id="secondary-bttn"
                        >
                            {secondaryButtonTitle}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
);

InformationAlertBanner.displayName = 'InformationAlertBanner';
